var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.type == 1)?_c('CollectModel',{ref:"CollectModel",on:{"handleStart":_vm.handleStart}}):_vm._e(),(_vm.type == 2)?_c('OfficialCollect',{ref:"OfficialCollect"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }